import { OnboardingConfigDTO, OnboardingModuleEnum } from "front-lib";

export const coverageOnboarding: OnboardingConfigDTO = {
    module: OnboardingModuleEnum.SETTINGS_COVERAGE,
    steps: [
        {
            id: "cov-welcome",
            title: "Área de Cobertura",
            description:
                "Defina a área geográfica onde sua plataforma opera. Corridas fora desta área não serão aceitas.",
            position: "center",
        },
        {
            id: "cov-map",
            title: "Mapa de Cobertura",
            description:
                "Use as ferramentas de desenho para delimitar a área de operação no mapa. Você pode criar polígonos, círculos ou retângulos.",
            targetId: "coverage-map",
            position: "top",
        },
        {
            id: "cov-save",
            title: "Salvar Área",
            description:
                "Após desenhar a área, clique em salvar. A cobertura é validada pelo backend para cada nova corrida.",
            targetId: "coverage-save-btn",
            position: "top",
        },
    ],
};
